import React from 'react'
import { css } from '@emotion/css'

import { DebugAdUnitRow } from './DebugAdUnitsRow'
import { breakpoint, calcRem } from 'component-library/__styling/style-functions'
import { AdState } from 'common/advertising/ad-state'
import { AdDefinition } from 'common/advertising/add-ads'

export const DebugAdUnitsTable: React.FC<{
    adState: AdState
    ads: AdDefinition[]
    forBreakpoint: number
}> = ({ ads, adState, forBreakpoint }) => {
    const theadClassName = css({ tr: { td: { [breakpoint('sm')]: { minWidth: calcRem(50) } } } })

    return (
        <table className={css({ borderCollapse: 'collapse', borderSpacing: 0, width: '100%' })}>
            <thead className={theadClassName}>
                <tr>
                    <td>Ad slot type</td>
                    <td>pos</td>
                    <td>slot id</td>
                    <td>ad sizes</td>
                    <td>ad pos category</td>
                    <td>exclusion labels</td>
                </tr>
            </thead>
            <tbody>
                {ads.map(ad => (
                    <DebugAdUnitRow
                        ad={ad}
                        adState={adState}
                        forBreakpoint={forBreakpoint}
                        key={ad.id}
                    />
                ))}
            </tbody>
        </table>
    )
}
